import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { WebCopySource } from 'app/model/pipeline/copysource/web.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(WebCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts
    }
})
export class WebCopySourceAdapter extends CopySourceAdapter<WebCopySource, Model.WebSource> {
    protected override async _toResource(copySource: WebCopySource): Promise<Model.WebSource> {
        return this.getCommonCopySourceProperties(copySource, Metamodel.modelFor(WebCopySource).name);
    }

    protected override async _toModel(resource: Model.WebSource, copyActivity: CopyActivity): Promise<WebCopySource> {
        return this.createCopySourceWithCommonProperties(WebCopySource.MODEL, resource, copyActivity) as WebCopySource;
    }
}
